module.exports = __webpack_public_path__ + "img/pacman.bad25c49.svg";